
import Vue from 'vue'
import {NewAlertDestinationsApiFunc, setAccessToken} from '@/api'
import { AlertDestination } from '@/models'

import AlertDestinationList from './components/AlertDestinationList.vue'
import Pager from '@/components/BasePager.vue'
import TheTemplate from '../TheTemplate.vue'

export type DataType = {
  alertDestinations: Array<AlertDestination>;
  totalPage: number;
  currentPage: number;
}

export default Vue.extend({
  name: 'AlertDestinationListScreen',

  data(): DataType {
    return {
      alertDestinations: [],
      totalPage: 0,
      currentPage: 0
    }
  },

  mounted() {
    this.fetchAlertDestinations()
  },

  watch: {
    $route(to, from) {
      if (to.params.updated === 'true') {
        this.fetchAlertDestinations(this.currentPage)
      }
    }
  },

  components: {
    TheTemplate,
    AlertDestinationList,
    Pager
  },

  methods: {
    async fetchAlertDestinations(page?: number): Promise<void> {
      const companyId = this.$auth.companyId
      if (!companyId) {
        this.$router.replace({name: 'login'})
        return
      }
      const filterString = ''
        setAccessToken(this.$auth.accessToken)
        const { data, err } = await NewAlertDestinationsApiFunc().listAlertDestinations(companyId, filterString, page)

      if (err != null) {
        this.$handleApiError(err, () => {
          this.fetchAlertDestinations(page)
        })
        return
      }

      this.alertDestinations = data.list
      this.currentPage = data.currentPage
      this.totalPage = data.totalPage
    },

    changePage(page: number): void {
      this.fetchAlertDestinations(page)
    },
  }
})
